import cx from 'classnames';
import type { FunctionComponent } from 'react';
import { useCallback } from 'react';

import { boardSwitcherSharedState } from '@trello/board-switcher';
import { useFeatureGate } from '@trello/feature-gate-client';
import { useSharedStateSelector } from '@trello/shared-state';
import { useSplitScreenSharedState } from '@trello/split-screen';

import { SearchField } from './SearchField';
import { ToggleLayoutButton } from './ToggleLayoutButton';
import { TogglePanelButton } from './TogglePanelButton';

import * as styles from './BoardSwitcherHeader.module.less';

interface BoardSwitcherHeaderProps {
  isPanel?: boolean;
}

export const BoardSwitcherHeader: FunctionComponent<
  BoardSwitcherHeaderProps
> = ({ isPanel }) => {
  const { value: isListViewEnabled } = useFeatureGate(
    'billplat_board_switcher_settings',
  );
  const { value: isBoardSwitcherPanelEnabled } = useFeatureGate(
    'billplat_board_switcher_panel',
  );

  const { configuration: splitScreenConfiguration } =
    useSplitScreenSharedState();

  const switcherMode = useSharedStateSelector(
    boardSwitcherSharedState,
    useCallback((state) => state.mode, []),
  );

  const shouldShowToggleLayoutButton =
    isListViewEnabled &&
    switcherMode === 'modal' &&
    splitScreenConfiguration !== 'tabs';

  return (
    <div
      className={cx(styles.container, {
        [styles.panel]: isPanel,
      })}
    >
      <SearchField />
      {shouldShowToggleLayoutButton && <ToggleLayoutButton />}
      {isBoardSwitcherPanelEnabled && <TogglePanelButton />}
    </div>
  );
};
